import axios from './axiosInstance';


export const getAllEvents = () => {
  return axios.get('/events');
};

export const getEventWorkmenList = (filter) => {
  return axios.get('/event/workmen-list', { params: { ...filter } });
};

//send -invite
export const sendInvite = (data) => {
  return axios.post('/send-invite', data);
};

export const getWorkmanById = (id) => {
  return axios.get(`/workman/${id}`);
};

export const updateWorkmanTransactionStatus = (payload) => {
  return axios.post('/workman/update-transaction-status', payload);
};